import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardMeLabOrderListUX = (props: any) => {
    return(
      <div
        id="CardLabOrderListUX-div-0"
        style={{ height: "80vh" }}>
        <div
          id="CardLabOrderListUX-div-1"
          style={{padding: "10px" }}>
          
          <Form
            id="CardLabOrderListUX-Form-2">
            <FormGroup
              id="CardLabOrderListUX-FormGroup-3">
              <FormField
                id="CardLabOrderListUX-FormField-5">
                <label
                  id="CardLabOrderListUX-label-13"
                  style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Lab Order List
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardLabOrderListUX-FormGroup-4"
              style={{ display: "flex", alignItems: "flex-end" }}>
              <FormField
                id="CardLabOrderListUX-FormField-6"
                width={3}>
                <label
                  id="CardLabOrderListUX-label-14">
                  
                </label>
                <Input
                  icon="search"
                  id="CardLabOrderListUX-Input-21"
                  name="selectedBarcode"
                  onChange={props.onChangeFilter}
                  placeholder="ค้นหาด้วย LabID"
                  value={props.labOrderQueue?.selectedBarcode}>
                </Input>
              </FormField>
              <FormField
                id="CardLabOrderListUX-FormField-7"
                width={3}>
                <label
                  id="CardLabOrderListUX-label-15">
                  วันที่สั่ง Lab Center
                </label>
                <DateTextBox
                  id="CardLabOrderListUX-DateTextBox-23"
                  onChange={props.onChangeStartDate}
                  value={props.labOrderQueue?.selectedStartDate}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardLabOrderListUX-FormField-8"
                width={3}>
                <label
                  id="CardLabOrderListUX-label-16">
                  
                </label>
                <DateTextBox
                  id="CardLabOrderListUX-DateTextBox-24"
                  onChange={props.onChangeEndDate}
                  value={props.labOrderQueue?.selectedEndDate}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardLabOrderListUX-FormField-9"
                width={3}>
                <label
                  id="CardLabOrderListUX-label-17">
                  Lab Center
                </label>
                <Dropdown
                  fluid={true}
                  id="CardLabOrderListUX-Dropdown-25"
                  name="selectedLabCenter"
                  onChange={props.onChangeFilter}
                  options={props.labCenterOptions}
                  selection={true}
                  value={props.labOrderQueue?.selectedLabCenter}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardLabOrderListUX-FormField-10"
                width={3}>
                <label
                  id="CardLabOrderListUX-label-18">
                  สถานะ
                </label>
                <Dropdown
                  fluid={true}
                  id="CardLabOrderListUX-Dropdown-26"
                  name="selectedStatus"
                  onChange={props.onChangeFilter}
                  options={props.labItemStatusOptions}
                  selection={true}
                  value={props.labOrderQueue?.selectedStatus}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardLabOrderListUX-FormField-31"
                style={{ display: "flex", alignItems: "flex-end" }}>
                <div
                  id="CardLabOrderListUX-div-32">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardLabOrderListUX-FormGroup-27">
              <FormField
                id="CardLabOrderListUX-FormField-28"
                width={16}>
                <div
                  id="CardLabOrderListUX-div-29"
                  style={{ width: "100%",  }}>
                  
                  <Table
                    className="--rt-tbody-overflow-y-hidden"
                    data={props.lapOrderList}
                    defaultPageSize="10"
                    getTrProps={props.rowProps}
                    headers={`วันเวลาที่สั่ง,LabID,บริการตรวจ,ชื่อ Package / รายการตรวจสอบ,วันเวลาที่รับเข้า,สถานะ,Action`}
                    id="CardLabOrderListUX-Table-30"
                    keys="orderDate,accessNumber,serviceType,orderName,arriveDate,status_name,action"
                    minRows="10"
                    pageSize="10"
                    showPagination={false}
                    style={{height: "50vh"}}
                    widths="^150,auto,^120,^300,^150,auto,^220">
                  </Table>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardMeLabOrderListUX

export const screenPropsDefault = {}

/* Date Time : Fri Jun 19 2026 15:05:33 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"80vh\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormGroup-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormGroup-4"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-6"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-7"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-8"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-10"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-11"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Order List"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-13"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"16px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สั่ง Lab Center"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Center"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-label-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Input",
      "parent": 6,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Input-21"
        },
        "name": {
          "type": "value",
          "value": "selectedBarcode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาด้วย LabID"
        },
        "value": {
          "type": "code",
          "value": "props.labOrderQueue?.selectedBarcode"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 23,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-DateTextBox-23"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.labOrderQueue?.selectedStartDate"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 24,
      "name": "DateTextBox",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-DateTextBox-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.labOrderQueue?.selectedEndDate"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Dropdown-25"
        },
        "name": {
          "type": "value",
          "value": "selectedLabCenter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.labCenterOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.labOrderQueue?.selectedLabCenter"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 10,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Dropdown-26"
        },
        "name": {
          "type": "value",
          "value": "selectedStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.labItemStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.labOrderQueue?.selectedStatus"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormGroup-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-28"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\",  }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 30,
      "name": "Table",
      "parent": 29,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.lapOrderList"
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "code",
          "value": "`วันเวลาที่สั่ง,LabID,บริการตรวจ,ชื่อ Package / รายการตรวจสอบ,วันเวลาที่รับเข้า,สถานะ,Action`"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Table-30"
        },
        "keys": {
          "type": "value",
          "value": "orderDate,accessNumber,serviceType,orderName,arriveDate,status_name,action"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"50vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "^150,auto,^120,^300,^150,auto,^220"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-FormField-31"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-end\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardMeLabOrderListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
